import React, { ChangeEvent } from "react";
import { CommentDetail } from "../../../entities/formTemplateDataType";
import { Chevrondown } from "../../../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-chevron-down.svg";

const CMACommentHeaderComponent = ({
    cmaRole,
    comment,
    index,
    isCommentOwner,
    handleComentChange,
    deleteComment
}: {
    cmaRole: 'A' | 'C',
    comment: CommentDetail,
    index: number,
    isCommentOwner: boolean,
    handleComentChange: (e: ChangeEvent<HTMLInputElement>, value: string, index: number) => void,
    deleteComment: (index: number) => void,
}) => {
    const url = process.env.PUBLIC_URL==='/' ? '' : `${process.env.PUBLIC_URL?.endsWith('/') ? process.env.PUBLIC_URL.slice(0, -1) : process.env.PUBLIC_URL}/public`;
    return (
        <div className='comment-header'>
            <div className="comment-title-sectioin">
                <div className="comment-indicator">{comment.role ?? cmaRole}</div>
                <div className="comment-owner">
                    <p style={{marginBottom: '0'}}><b>{comment.MadeBy ?? ''}</b></p>
                    <span>{comment.MadeOn ?? ''}</span>
                </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}  key={`Checkbox_${comment.id ?? ''}_${index}`} title={comment.Comments}>
                {!comment.Resolved && cmaRole==='C' && !isCommentOwner && (
                    <div className="ontario-checkboxes__item">
                        <input
                            style={{opacity: '1', width: '30px', height: '30px'}}
                            className="ontario-checkboxes__input"
                            id={`comment_${comment.id ?? ''}_${index}`}
                            key={`coment_key_${index}`}
                            name={`comment_${index}`}
                            type="checkbox"
                            onChange={(e) => handleComentChange(e, comment.Comments, index)}
                        />
                    </div>
                )}
                {(isCommentOwner || (cmaRole === 'A' && comment.Resolved)) && (
                    <button className="message_button" style={{backgroundColor: '#f2f2f2', border: 'none'}} onClick={() =>deleteComment(index)}>
                        <img src={`${url}/assets/css/ontario-design-system/icons/svg/ontario-icon-delete.svg`}/>
                    </button>
                )}
                <button className="message_button" style={{background: `${comment.Resolved? '#f2f2f2' : '#e2f0f4'}`, border: 'none'}}>
                    {/* <Chevrondown /> */}
                    <img src={`${url}/assets/css/ontario-design-system/icons/svg/ontario-icon-chevron-down.svg`} alt="Chevron Down" />
                </button>
            </div>
        </div>
    );
}

export default CMACommentHeaderComponent;